
    <corp-card 
        class="transition-all duration-500 transform p-0! cursor-pointer"
        [ngClass]="{
            'opacity-0 translate-y-4': !loaded,
            'opacity-100 translate-y-0': loaded,
            'fixed left-1/2 -translate-x-1/2 top-[5%] 
            w-[70%] max-w-sm z-50
            scale-105 shadow-2xl': selectedId
        }"

        (click)="select(pickupPoint?.place?.id!)"

        [corp-content]="tp_corp_card_pickup_point" > 
    </corp-card>
   
        <!-- ======== -->
        <!-- TEMPLATES -->
        <!-- ======= -->
            
        <ng-template #tp_corp_card_pickup_point>

                <!-- BADGE CHECK -->
                @if(selectedId) {
                    <div class="absolute top-3 right-2 w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center shadow"> 
                        <svg class="w-4 h-4 text-white"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="3"
                            viewBox="0 0 24 24">
                        <path stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                }
                    <div class="trezo-card-header mb-[20px] flex items-center justify-between">
                        <div class="trezo-card-title">
                            <h5 class="!mb-0">
                                {{ pickupPoint?.place?.label }}
                            </h5>
                        </div>
                    </div>
                    <div class="trezo-card-content">
                        <div class="block relative inline-block">
                            <img [src]="getPickupPointUrlImage(pickupPoint)" 
                                class="rounded-[5px]" 
                                alt="property-image">
                            <span class="material-symbols-outlined 
                                        absolute top-0 left-0 
                                        m-2 p-1/2 
                                        bg-white rounded-sm shadow-md">
                                person_pin_circle
                            </span>
                        </div>
                        <div class="flex items-center justify-between mb-[9px] mt-[20px]">

                        </div>
                        <span class="block relative pt-px ltr:pl-[22px] rtl:pr-[22px]">
                            <i class="material-symbols-outlined text-primary-500 absolute ltr:-left-[2px] rtl:-right-[2px] top-1/2 -translate-y-1/2 !text-[19px]">
                                location_on
                            </i>
                            {{ pickupPoint?.address?.streetName }} {{ pickupPoint?.address?.streetNumber }} <br>
                            {{ pickupPoint?.address?.postalCode }} {{ pickupPoint?.address?.city }} <br>
                            {{ pickupPoint?.address?.state }}
                        </span>
                        <div class="mt-[20px] flex items-center justify-end">
                            <!-- <span class="inline-block text-xs rounded-[4px] bg-secondary-100 text-secondary-600 dark:bg-[#15203c] text-xs py-px px-[9px] mr-2">
                                i18n: Agency Code
                                {{ 'i18n.app.features.pages.order.wizard.step_02.pickup-point-card.span_01' | translate }}
                            </span> 
                            <div class="!mb-0 !text-secondary-500">
                                {{ pickupPoint?.place?.code }}
                            </div> -->
                        </div>
                    </div>
     
        </ng-template>

        



